import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HCOMMERCE, LANDSCAPE } from "../../../config/Constant";
import { StoreLevel2_Potrait } from "./storeLevel2_Potrait";
import { StoreLevel2_Landscape } from "./storeLevel2_landscape";
import { sendAnalytics } from "../../../Redux/Actions/analyticsAction";
import { setRenderFlashMessage } from "../../../Redux/Actions/appConfigAction";

export const StoreLevel2 = (props) => {
    const dispatch = useDispatch();
    const { handleItemInfo, menuIsAvailable = true, handleAddToCart, selectedStoreItemSubType } = props;

    const { appOrientation } = useSelector(state => (state.appConfigSlice));
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);


    const showMenuUnavailableToast = () => {
        dispatch(setRenderFlashMessage(true, {
            type: 'info',
            message: 'This menu is currently not available for ordering.',
        }));
    };

    const onItemPress = (item, hasItemAddOns) =>
        menuIsAvailable ? handleItemInfo({ ...item, hasItemAddOns }) : showMenuUnavailableToast();

    const onAddPress = (item, hasItemAddOns) =>
        menuIsAvailable ? handleAddToCart({ ...item, hasItemAddOns }) : showMenuUnavailableToast();

    

    useEffect(() => {
        dispatch(sendAnalytics(HCOMMERCE, "STORE LEVEL - 2", { storeName: props.storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken, subStoreName: selectedStoreItemSubType.subTypeName, subStoreSku: selectedStoreItemSubType.sku }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (appOrientation == LANDSCAPE) {
        return <StoreLevel2_Landscape 
            {...props} 
            onItemPress={onItemPress}
            onAddPress={onAddPress}
        />;
    } else {
        return <StoreLevel2_Potrait 
            {...props}
            onItemPress={onItemPress}
            onAddPress={onAddPress}
        />;
    }
}